import React, { useEffect, useState, useRef, useCallback} from 'react';
import { Grid, TextField, Button, Box
} from '@mui/material';
import { useForm } from "react-hook-form";
import { Loader } from "@googlemaps/js-api-loader";
import { useSnackbar } from 'notistack';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

const PropertyInfo = ({onSuccess, onBackButtonClick, propertyData={} }) => {

  const defaultValues = {
    searchArea:'',
  };

  /** Hooks */
  const [area, setArea] = useState('');
  const { enqueueSnackbar } = useSnackbar();
  const [locationCoordinates, setLocationCoordinates] = useState(getMapCoordinates(propertyData));
  const { handleSubmit } = useForm({
    mode: 'onTouched',
    defaultValues
  });
  const placesInputRef = useRef(null);
  const markerRef = useRef(null);
  const mapRef = useRef(null);
  const googleRef = useRef(null);

  useEffect(() => {
    loadGoogleMaps();
    // onSuccess({ libraryId: '775d7cca-5911-4c3b-8c1c-6e313a2b0d6c'});
    return () => {};
  }, []);

  useEffect(() => {
    if(propertyData){
      const { searchArea, locationCoordinates } = propertyData;
      
      placesInputRef.current.value = searchArea || "";
      setArea(searchArea || "");
      if(locationCoordinates?.latitude && locationCoordinates?.longitude) {
        setLocationCoordinates({latitude: locationCoordinates.latitude , longitude: locationCoordinates.longitude});
        // if(mapRef.current && googleRef.current) {
        //   markerRef.current = new googleRef.current.maps.Marker({
        //     position: {...cordinates},
        //     map: mapRef.current,
        //     title: 'Your Library'
        //   }); 
        //   mapRef.current.setCenter({ ...cordinates });
        //   mapRef.current.setZoom(12)
        // }
      }
    }
  
    return () => {};
  }, [propertyData]);

  function getMapCoordinates(_propertyData = {} ) {
    const { locationCoordinates } = _propertyData;
    let cordinates = null;
    if(locationCoordinates?.latitude && locationCoordinates?.longitude) {
      cordinates = { latitude: locationCoordinates.latitude, longitude: locationCoordinates.longitude};
      return cordinates;
    }
    return cordinates;
  }
  
  useEffect(() => {
    if(locationCoordinates?.latitude && locationCoordinates?.longitude && googleRef.current?.maps) {
      const cordinates = { lat: locationCoordinates.latitude, lng: locationCoordinates.longitude}
      if (markerRef.current == null) {
        markerRef.current = new googleRef.current.maps.Marker({
            position: {...cordinates},
            map: mapRef.current,
            title: 'Your Library'
        }); 
      } else {
        markerRef.current.setPosition({...cordinates}); 
      } 
      mapRef.current.setCenter({ ...cordinates });
      mapRef.current.setZoom(12)
    }
    return () => {};
  }, [locationCoordinates, mapRef]);
  
  
  const loadGoogleMaps = useCallback(() => {
    const mapOptions = {
      center: {
        lat: 12.9715987,
        lng: 77.5945627
      },
      zoom: 12,
      // disableDefaultUI: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
    };

    const loader = new Loader({
      apiKey: "AIzaSyCy5CeZ-EXuV8dpaIXi5-hEomhJVwdBVV8",
      version: "weekly",
      libraries: ["places"],
      componentRestrictions: {country: 'in' }
    });

    loader.load().then((google) => {
      googleRef.current =  google;
      const mapEle = document.getElementById("map");
      mapRef.current =  new google.maps.Map(mapEle, mapOptions);

      google.maps.event.addListener(mapRef.current, 'click', function(event) {
        const location = event.latLng;
        // if (markerRef.current == null) {
        //   markerRef.current = new google.maps.Marker({
        //       position: location,
        //       map: mapRef.current,
        //       title: 'Your Library'
        //   }); 
        // } else {
        //   markerRef.current.setPosition(location); 
        // } 
        setLocationCoordinates({latitude:location.lat() , longitude: location.lng()});
      });
      initPlacesAutoComplete(google, mapRef.current); 

      if(locationCoordinates.latitude && locationCoordinates.longitude) {
        const cordinates = { lat: locationCoordinates.latitude, lng: locationCoordinates.longitude}
        markerRef.current = new googleRef.current.maps.Marker({
          position: {...cordinates},
          map: mapRef.current,
          title: 'Your Library'
        }); 
        mapRef.current.setCenter({ ...cordinates });
        mapRef.current.setZoom(12);
      }
    })
    .catch(e => {
      // do something
    });
    
  },[locationCoordinates]);

  const initPlacesAutoComplete = (google, map) => {

    const options = {
      fields: [ "geometry","name" ],
      componentRestrictions: {country: 'in'},
      // strictBounds: false,
      // types: ["establishment"],
    };
    const autocomplete = new google.maps.places.Autocomplete(placesInputRef.current, options);
    autocomplete.addListener("place_changed", () => {
      // infowindow.close();
      // marker.setVisible(false);
      const place = autocomplete.getPlace();

      // setValue('searchArea', place.formatted_address, {shouldValidate: true, shouldDirty: true});
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();

      map.setCenter({lat, lng});
      map.setZoom(12)
      setArea(place.name);
    });
  };



  const onSubmit = () => {
    if(!locationCoordinates) {
      enqueueSnackbar("Select library location", {variant: 'error'});
    }else{
      onSuccess({locationCoordinates, searchArea: area})
    }
  }

  return (
    <Box sx={{ mb: 2, mt:2, px: 4 }} noValidate component="form"  onSubmit={handleSubmit(onSubmit)} >
      <Grid container justifyContent="center" >
        <Grid container item xs={12} sm={12} md={10} lg={8}>
          <Grid item xs={12} sm={12} md={12} lg={12} sx={{ position: 'relative'}}>
            {/* <Controller
              control={control}
              name="searchArea"
              id="searchArea"
              required
              rules={{ required: "Enter search area" }}
              render={({field}) => ( */}
                <TextField
                  // {...field}
                  margin="normal"
                  label="Search Area"
                  required
                  size="small"
                  fullWidth
                  inputRef={placesInputRef}
                />
              {/* )}
            /> */}
            <Box id="map" component="div" sx={{width: '100%', height: 500, mt: 1}}></Box>
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
           <Button
            onClick={onBackButtonClick}
            variant="outlined"
            sx={{ mt: 4, mb: 2, mr: 2 }}
            startIcon={<ArrowBackIosNewIcon />}
            color="info"
          >
            Back
          </Button>
          <Button
            type="submit" 
            variant="contained"
            sx={{ mt: 4, mb: 2 }}
            startIcon={<ArrowForwardIosIcon />}
            color="warning"
          >
            Next
          </Button>
        </Grid>
      </Grid>
    </Box>
      
  );

}
 
export default React.memo(PropertyInfo);
